// appsignal.js

import Appsignal from "@appsignal/javascript"

export const appsignal = new Appsignal({
  key: import.meta.env.VITE_APPSIGNAL_FRONTEND_KEY,
})
